import { useEffect, useState } from "react";
import axios from "axios";

const SubscriptionStatus = () => {
  const [trialDaysLeft, setTrialDaysLeft] = useState(null);
  const [endDateDaysLeft, setEndDateDaysLeft] = useState(null);
  const [subscriptionExpired, setSubscriptionExpired] = useState(false);
  const [trialExtensionDays, setTrialExtensionDays] = useState(0);

  useEffect(() => {
    const fetchTrialExtensionDays = async () => {
      try {
        const UserID = localStorage.getItem('UserID');
        if (UserID) {
          // Fetch user profile to get TrialExtensionDays
          const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/get-profile-info`, {
            params: { UserID }
          });
          
          if (response.data && response.data.length > 0) {
            const userData = response.data[0];
            setTrialExtensionDays(userData.TrialExtensionDays || 0);
          }
        }
      } catch (error) {
        console.error('Error fetching trial extension days:', error);
      }
    };

    fetchTrialExtensionDays();
  }, []);

  useEffect(() => {
    const createdDateStr = localStorage.getItem("CreatedDate");
    const endDateStr = localStorage.getItem("subscriptionEndDate");
    const today = new Date();
    today.setHours(0, 0, 0, 0);
  
    let subscriptionTaken = false;
  
    if (endDateStr) {
      const endDate = new Date(endDateStr);
      endDate.setHours(0, 0, 0, 0);
  
      const subscriptionDaysLeft = Math.ceil((endDate - today) / (1000 * 60 * 60 * 24));
      if (subscriptionDaysLeft >= 0) {
        subscriptionTaken = true;
  
        if (subscriptionDaysLeft <= 7) {
          setEndDateDaysLeft(subscriptionDaysLeft); // Show reminder only if about to end
        }
      }
    }
  
    // Show trial info only if no subscription was taken
    if (!subscriptionTaken && createdDateStr) {
      const createdDate = new Date(createdDateStr);
      createdDate.setHours(0, 0, 0, 0);
  
      const trialDaysUsed = Math.floor((today - createdDate) / (1000 * 60 * 60 * 24));
      // UPDATED: Include TrialExtensionDays in calculation
      const totalTrialDays = 30 + trialExtensionDays;
      const trialDaysRemaining = totalTrialDays - trialDaysUsed;
  
      if (trialDaysRemaining > 0) {
        setTrialDaysLeft(trialDaysRemaining); // Still in trial
      } else {
        setSubscriptionExpired(true); // Trial ended, no subscription
      }
    }
  }, [trialExtensionDays]);
  

  return (
      <>
        {trialDaysLeft !== null && (
          <div style={{ backgroundColor: "#cce5ff", padding: "10px", borderRadius: "8px", marginBottom: "10px",marginTop:"10px" }}>
            <strong>Trial:</strong> {trialDaysLeft} day{trialDaysLeft > 1 ? "s" : ""} left in your free trial.
            {trialExtensionDays > 0 && (
              <div style={{ fontSize: "0.9em", color: "#0066cc", marginTop: "5px" }}>
                🎉 Extended by {trialExtensionDays} days through credit redemption!
              </div>
            )}
          </div>
        )}
    
        {endDateDaysLeft !== null && (
          <div style={{ backgroundColor: "#fff3cd", padding: "10px", borderRadius: "8px", marginBottom: "10px",marginTop:"10px" }}>
            <strong>Reminder:</strong> Your subscription ends in <strong>{endDateDaysLeft} day{endDateDaysLeft > 1 ? "s" : ""}</strong>.
          </div>
        )}
    
        {subscriptionExpired && (
          <div style={{ backgroundColor: "#f8d7da", padding: "10px", borderRadius: "8px", marginBottom: "10px" ,marginTop:"10px"}}>
            <strong>Notice:</strong> Your trial has ended. Please subscribe to continue using the service.
          </div>
        )}
      </>
    );
    

};



export default SubscriptionStatus;
